import styled from 'styled-components';

export const FlexFill = styled.div`
flex: 1 0 0%;
`;
